import lodash from 'lodash';
import security from 'stores/security';
import type { CountryData } from 'types/common';

// 从url中获取customerid信息
export function getCustomerIdFromUrl(): number | undefined {
    const customerId = window.location.pathname.match(/(modify|esop|open|capability|update|agreement)\/(\d+)\/?/)?.[2];

    if (customerId) {
        return Number(customerId);
    }

    return;
}

/**
 * @description 判断用户信息是否是空值, 空值一般是null, undefined 或者空字符串
 * 0不能认为是空值, 因为某些字段的值是可以为0的
 */
export function isEmptyValue(value): boolean {
    return lodash.isNil(value) || value === '';
}

export function getOpenCacheKey(source?: string) {
    const openCacheKeyPrefix =
        source === 'esop' ? '__TIGER_PORTAL_ESOP_ACCOUNTS_PARAMS__' : '__TIGER_PORTAL_ACCOUNTS_PARAMS__';

    return getDynamicCacheKey(openCacheKeyPrefix);
}

/**
 * @description 获取动态的cacheKey, 用于在缓存中区分不同用户的数据
 * @param prefix 缓存前缀, 不同的业务模块用不同的前缀
 * @returns 返回一个拼接了用户uuid的cacheKey
 */
export function getDynamicCacheKey(prefix: string) {
    return `${prefix}${security.userInfo?.uuid || ''}`;
}

/**
 *  在非SSN开户流程中判断四个国家是否都为CHN（国籍、居住国、签发国、纳税国，页面不纳税国默认等于居住国）
 *  如果是则保持第二期仅支持CHN的非SSN开户流程，否则走第三期支持非CHN的非SSN开户流程 https://tigertech.feishu.cn/wiki/CPzBwLSswi6kP4kGHoFczcuFnnf
 */
export const checkFourCountryIsChn = (params: {
    country: string;
    issueCountry: string;
    legalResidenceCountry: string;
    taxResidenceCountry: string;
}) => {
    return Object.values(params).every(country => country === 'CHN');
};

export function getSearchCountryData(countryData: CountryData[], lowerSearchValue: string): CountryData[] {
    return countryData.reduce((prev, { items, letter }) => {
        // 避免搜索时某个国家在热门国家与字母排序国家中同时出现，过滤一下
        if (letter.match(/^[a-zA-Z]$/)) {
            // 搜索值模糊匹配内容包括国家名称、国家代码、英文名称、拼音、电话区号等
            const filteredItems = items.filter(
                ({ country, country_code, country_code2, country_en, pinyin, tel_code }) =>
                    [country, country_code, country_code2, country_en, pinyin, tel_code].some(item =>
                        // 并不是所有字段都一定存在
                        item?.replace(/-+/g, '').toLowerCase().includes(lowerSearchValue)
                    )
            );

            return filteredItems.length > 0 ? prev.concat({ letter, items: filteredItems }) : prev;
        }

        return prev;
    }, [] as CountryData[]);
}
